/**
 * Renders a metadata value as the text shown in its cell. Objects and arrays
 * are pretty-printed so they read the same way the JSON editor shows them;
 * nullish values collapse to an empty cell rather than the string "null".
 */
export function formatMetadataValue(value: unknown): string {
  if (value == null) {
    return ""
  }

  if (typeof value === "string") {
    return value
  }

  if (
    typeof value === "number" ||
    typeof value === "boolean" ||
    typeof value === "bigint"
  ) {
    return `${value}`
  }

  if (typeof value === "symbol" || typeof value === "function") {
    return value.toString()
  }

  if (typeof value === "object") {
    return JSON.stringify(value, null, 2)
  }

  return ""
}
